module.exports = __webpack_public_path__ + "img/7.02950fdf.png";